import i18n, { i18n_t } from '@/locales/i18n';
const phonePrefixOptions: Array<any> = [
  {
    label: i18n_t('中国大陆 +86'),
    value: '+86',
  },
  {
    label: i18n_t('中国香港 +852'),
    value: '+852',
  },
  {
    label: i18n_t('中国澳门 +853'),
    value: '+853',
  },
  {
    label: i18n_t('中国台湾 +886'),
    value: '+886',
  },
  {
    label: i18n_t('阿尔巴尼亚 +355'),
    value: '+355',
  },
  {
    label: i18n_t('阿尔及利亚 +213'),
    value: '+213',
  },
  {
    label: i18n_t('阿富汗 +93'),
    value: '+93',
  },
  {
    label: i18n_t('阿根廷 +54'),
    value: '+54',
  },
  {
    label: i18n_t('阿拉伯联合酋长国 +971'),
    value: '+971',
  },
  {
    label: i18n_t('阿鲁巴 +297'),
    value: '+297',
  },
  {
    label: i18n_t('阿曼 +968'),
    value: '+968',
  },
  {
    label: i18n_t('阿塞拜疆 +994'),
    value: '+994',
  },
  {
    label: i18n_t('阿森松岛 +247'),
    value: '+247',
  },
  {
    label: i18n_t('埃及 +20'),
    value: '+20',
  },
  {
    label: i18n_t('埃塞俄比亚 +251'),
    value: '+251',
  },
  {
    label: i18n_t('爱尔兰 +353'),
    value: '+353',
  },
  {
    label: i18n_t('爱沙尼亚 +372'),
    value: '+372',
  },
  {
    label: i18n_t('安道尔共和国 +376'),
    value: '+376',
  },
  {
    label: i18n_t('安哥拉 +244'),
    value: '+244',
  },
  {
    label: i18n_t('安圭拉 +1264'),
    value: '+1264',
  },
  {
    label: i18n_t('安提瓜和巴布达 +1268'),
    value: '+1268',
  },
  {
    label: i18n_t('奥地利 +43'),
    value: '+43',
  },
  {
    label: i18n_t('澳大利亚 +61'),
    value: '+61',
  },
  {
    label: i18n_t('巴巴多斯 +1246'),
    value: '+1246',
  },
  {
    label: i18n_t('巴布亚新几内亚 +675'),
    value: '+675',
  },
  {
    label: i18n_t('巴哈马 +1242'),
    value: '+1242',
  },
  {
    label: i18n_t('巴基斯坦 +92'),
    value: '+92',
  },
  {
    label: i18n_t('巴拉圭 +595'),
    value: '+595',
  },
  {
    label: i18n_t('巴勒斯坦 +970'),
    value: '+970',
  },
  {
    label: i18n_t('巴林 +973'),
    value: '+973',
  },
  {
    label: i18n_t('巴拿马 +507'),
    value: '+507',
  },
  {
    label: i18n_t('巴西 +55'),
    value: '+55',
  },
  {
    label: i18n_t('白俄罗斯 +375'),
    value: '+375',
  },
  {
    label: i18n_t('百慕大群岛 +1441'),
    value: '+1441',
  },
  {
    label: i18n_t('保加利亚 +359'),
    value: '+359',
  },
  {
    label: i18n_t('北马里亚纳群岛 +1670'),
    value: '+1670',
  },
  {
    label: i18n_t('北马其顿 +389'),
    value: '+389',
  },
  {
    label: i18n_t('贝宁 +229'),
    value: '+229',
  },
  {
    label: i18n_t('比利时 +32'),
    value: '+32',
  },
  {
    label: i18n_t('冰岛 +354'),
    value: '+354',
  },
  {
    label: i18n_t('波多黎各 +1787'),
    value: '+1787',
  },
  {
    label: i18n_t('波兰 +48'),
    value: '+48',
  },
  {
    label: i18n_t('波斯尼亚和黑塞哥维那 +387'),
    value: '+387',
  },
  {
    label: i18n_t('玻利维亚 +591'),
    value: '+591',
  },
  {
    label: i18n_t('伯利兹 +501'),
    value: '+501',
  },
  {
    label: i18n_t('博茨瓦纳 +267'),
    value: '+267',
  },
  {
    label: i18n_t('不丹 +975'),
    value: '+975',
  },
  {
    label: i18n_t('布基纳法索 +226'),
    value: '+226',
  },
  {
    label: i18n_t('布隆迪 +257'),
    value: '+257',
  },
  {
    label: i18n_t('朝鲜 +850'),
    value: '+850',
  },
  {
    label: i18n_t('赤道几内亚 +240'),
    value: '+240',
  },
  {
    label: i18n_t('丹麦 +45'),
    value: '+45',
  },
  {
    label: i18n_t('德国 +49'),
    value: '+49',
  },
  {
    label: i18n_t('东帝汶 +670'),
    value: '+670',
  },
  {
    label: i18n_t('多哥 +228'),
    value: '+228',
  },
  {
    label: i18n_t('多米尼加共和国 +1890'),
    value: '+1890',
  },
  {
    label: i18n_t('多米尼克 +1767'),
    value: '+1767',
  },
  {
    label: i18n_t('俄罗斯 +7'),
    value: '+7',
  },
  {
    label: i18n_t('厄瓜多尔 +593'),
    value: '+593',
  },
  {
    label: i18n_t('厄立特里亚 +291'),
    value: '+291',
  },
  {
    label: i18n_t('法国 +33'),
    value: '+33',
  },
  {
    label: i18n_t('法罗群岛 +298'),
    value: '+298',
  },
  {
    label: i18n_t('法属玻利尼西亚 +689'),
    value: '+689',
  },
  {
    label: i18n_t('法属圭亚那 +594'),
    value: '+594',
  },
  {
    label: i18n_t('瓜德罗普 +590'),
    value: '+590',
  },
  {
    label: i18n_t('梵蒂冈 +379'),
    value: '+379',
  },
  {
    label: i18n_t('菲律宾 +63'),
    value: '+63',
  },
  {
    label: i18n_t('斐济 +679'),
    value: '+679',
  },
  {
    label: i18n_t('芬兰 +358'),
    value: '+358',
  },
  {
    label: i18n_t('佛得角 +238'),
    value: '+238',
  },
  {
    label: i18n_t('福克兰群岛 +500'),
    value: '+500',
  },
  {
    label: i18n_t('刚果(布) +242'),
    value: '+242',
  },
  {
    label: i18n_t('刚果(金) +243'),
    value: '+243',
  },
  {
    label: i18n_t('哥伦比亚 +57'),
    value: '+57',
  },
  {
    label: i18n_t('哥斯达黎加 +506'),
    value: '+506',
  },
  {
    label: i18n_t('格林纳达 +1809'),
    value: '+1809',
  },
  {
    label: i18n_t('格陵兰 +299'),
    value: '+299',
  },
  {
    label: i18n_t('格鲁吉亚 +995'),
    value: '+995',
  },
  {
    label: i18n_t('古巴 +53'),
    value: '+53',
  },
  {
    label: i18n_t('关岛 +1671'),
    value: '+1671',
  },
  {
    label: i18n_t('圭亚那 +592'),
    value: '+592',
  },
  {
    label: i18n_t('哈萨克斯坦 +327'),
    value: '+327',
  },
  {
    label: i18n_t('海地 +509'),
    value: '+509',
  },
  {
    label: i18n_t('韩国 +82'),
    value: '+82',
  },
  {
    label: i18n_t('荷兰 +31'),
    value: '+31',
  },
  {
    label: i18n_t('荷属安的列斯 +599'),
    value: '+599',
  },
  {
    label: i18n_t('荷属圣马丁 +1721'),
    value: '+1721',
  },
  {
    label: i18n_t('黑山 +382'),
    value: '+382',
  },
  {
    label: i18n_t('洪都拉斯 +504'),
    value: '+504',
  },
  {
    label: i18n_t('基里巴斯 +686'),
    value: '+686',
  },
  {
    label: i18n_t('吉布提 +253'),
    value: '+253',
  },
  {
    label: i18n_t('吉尔吉斯坦 +331'),
    value: '+331',
  },
  {
    label: i18n_t('几内亚 +224'),
    value: '+224',
  },
  {
    label: i18n_t('几内亚比绍 +245'),
    value: '+245',
  },
  {
    label: i18n_t('加拿大 +1'),
    value: '+1',
  },
  {
    label: i18n_t('加纳 +233'),
    value: '+233',
  },
  {
    label: i18n_t('加蓬 +241'),
    value: '+241',
  },
  {
    label: i18n_t('柬埔寨 +855'),
    value: '+855',
  },
  {
    label: i18n_t('捷克 +420'),
    value: '+420',
  },
  {
    label: i18n_t('津巴布韦 +263'),
    value: '+263',
  },
  {
    label: i18n_t('喀麦隆 +237'),
    value: '+237',
  },
  {
    label: i18n_t('卡塔尔 +974'),
    value: '+974',
  },
  {
    label: i18n_t('开曼群岛 +1345'),
    value: '+1345',
  },
  {
    label: i18n_t('科摩罗 +269'),
    value: '+269',
  },
  {
    label: i18n_t('科索沃 +383'),
    value: '+383',
  },
  {
    label: i18n_t('科特迪瓦 +225'),
    value: '+225',
  },
  {
    label: i18n_t('科威特 +965'),
    value: '+965',
  },
  {
    label: i18n_t('克罗地亚 +385'),
    value: '+385',
  },
  {
    label: i18n_t('肯尼亚 +254'),
    value: '+254',
  },
  {
    label: i18n_t('库克群岛 +682'),
    value: '+682',
  },
  {
    label: i18n_t('拉脱维亚 +371'),
    value: '+371',
  },
  {
    label: i18n_t('莱索托 +266'),
    value: '+266',
  },
  {
    label: i18n_t('老挝 +856'),
    value: '+856',
  },
  {
    label: i18n_t('黎巴嫩 +961'),
    value: '+961',
  },
  {
    label: i18n_t('立陶宛 +370'),
    value: '+370',
  },
  {
    label: i18n_t('利比里亚 +231'),
    value: '+231',
  },
  {
    label: i18n_t('利比亚 +218'),
    value: '+218',
  },
  {
    label: i18n_t('列支敦士登 +423'),
    value: '+423',
  },
  {
    label: i18n_t('留尼旺 +262'),
    value: '+262',
  },
  {
    label: i18n_t('卢森堡 +352'),
    value: '+352',
  },
  {
    label: i18n_t('卢旺达 +250'),
    value: '+250',
  },
  {
    label: i18n_t('罗马尼亚 +40'),
    value: '+40',
  },
  {
    label: i18n_t('马达加斯加 +261'),
    value: '+261',
  },
  {
    label: i18n_t('马尔代夫 +960'),
    value: '+960',
  },
  {
    label: i18n_t('马耳他 +356'),
    value: '+356',
  },
  {
    label: i18n_t('马拉维 +265'),
    value: '+265',
  },
  {
    label: i18n_t('马来西亚 +60'),
    value: '+60',
  },
  {
    label: i18n_t('马里 +223'),
    value: '+223',
  },
  {
    label: i18n_t('马绍尔群岛 +692'),
    value: '+692',
  },
  {
    label: i18n_t('马提尼克 +596'),
    value: '+596',
  },
  {
    label: i18n_t('毛里求斯 +230'),
    value: '+230',
  },
  {
    label: i18n_t('美国 +1'),
    value: '+1',
  },
  {
    label: i18n_t('美属萨摩亚 +1684'),
    value: '+1684',
  },
  {
    label: i18n_t('美属维尔京群岛 +1340'),
    value: '+1340',
  },
  {
    label: i18n_t('蒙古 +976'),
    value: '+976',
  },
  {
    label: i18n_t('蒙特塞拉特岛 +1664'),
    value: '+1664',
  },
  {
    label: i18n_t('孟加拉国 +880'),
    value: '+880',
  },
  {
    label: i18n_t('秘鲁 +51'),
    value: '+51',
  },
  {
    label: i18n_t('密克罗尼西亚 +691'),
    value: '+691',
  },
  {
    label: i18n_t('缅甸 +95'),
    value: '+95',
  },
  {
    label: i18n_t('摩尔多瓦 +373'),
    value: '373',
  },
  {
    label: i18n_t('摩洛哥 +212'),
    value: '+212',
  },
  {
    label: i18n_t('摩纳哥 +377'),
    value: '+377',
  },
  {
    label: i18n_t('莫桑比克 +258'),
    value: '+258',
  },
  {
    label: i18n_t('墨西哥 +52'),
    value: '+52',
  },
  {
    label: i18n_t('纳米比亚 +264'),
    value: '+264',
  },
  {
    label: i18n_t('南非 +27'),
    value: '+27',
  },
  {
    label: i18n_t('南苏丹 +211'),
    value: '+211',
  },
  {
    label: i18n_t('瑙鲁 +674'),
    value: '+674',
  },
  {
    label: i18n_t('尼加拉瓜 +505'),
    value: '+505',
  },
  {
    label: i18n_t('尼泊尔 +977'),
    value: '+977',
  },
  {
    label: i18n_t('尼日尔 +227'),
    value: '+227',
  },
  {
    label: i18n_t('尼日利亚 +234'),
    value: '+234',
  },
  {
    label: i18n_t('纽埃 +683'),
    value: '+683',
  },
  {
    label: i18n_t('挪威 +47'),
    value: '+47',
  },
  {
    label: i18n_t('诺福克岛 +672'),
    value: '+672',
  },
  {
    label: i18n_t('帕劳 +680'),
    value: '+680',
  },
  {
    label: i18n_t('葡萄牙 +351'),
    value: '+351',
  },
  {
    label: i18n_t('日本 +81'),
    value: '+81',
  },
  {
    label: i18n_t('瑞典 +46'),
    value: '+46',
  },
  {
    label: i18n_t('瑞士 +41'),
    value: '+41',
  },
  {
    label: i18n_t('萨尔瓦多 +503'),
    value: '+503',
  },
  {
    label: i18n_t('西萨摩亚 +685'),
    value: '+685',
  },
  {
    label: i18n_t('南斯拉夫 +381'),
    value: '+381',
  },
  {
    label: i18n_t('塞拉利昂 +232'),
    value: '+232',
  },
  {
    label: i18n_t('塞内加尔 +221'),
    value: '+221',
  },
  {
    label: i18n_t('塞浦路斯 +357'),
    value: '+357',
  },
  {
    label: i18n_t('塞舌尔 +248'),
    value: '+248',
  },
  {
    label: i18n_t('沙特阿拉伯 +966'),
    value: '+966',
  },
  {
    label: i18n_t('圣多美和普林西比 +239'),
    value: '+239',
  },
  {
    label: i18n_t('圣卢西亚 +1758'),
    value: '+1758',
  },
  {
    label: i18n_t('圣马力诺 +378'),
    value: '+378',
  },
  {
    label: i18n_t('圣文森特岛 +1784'),
    value: '+1784',
  },
  {
    label: i18n_t('斯里兰卡 +94'),
    value: '+94',
  },
  {
    label: i18n_t('斯洛伐克 +421'),
    value: '+421',
  },
  {
    label: i18n_t('斯洛文尼亚 +386'),
    value: '+386',
  },
  {
    label: i18n_t('斯威士兰 +268'),
    value: '+268',
  },
  {
    label: i18n_t('苏丹 +249'),
    value: '+249',
  },
  {
    label: i18n_t('苏里南 +597'),
    value: '+597',
  },
  {
    label: i18n_t('所罗门群岛 +677'),
    value: '+677',
  },
  {
    label: i18n_t('索马里 +252'),
    value: '+252',
  },
  {
    label: i18n_t('塔吉克斯坦 +992'),
    value: '+992',
  },
  {
    label: i18n_t('泰国 +66'),
    value: '+66',
  },
  {
    label: i18n_t('坦桑尼亚 +255'),
    value: '+255',
  },
  {
    label: i18n_t('汤加 +676'),
    value: '+676',
  },
  {
    label: i18n_t('特立尼达和多巴哥 +1809'),
    value: '+1809',
  },
  {
    label: i18n_t('突尼斯 +216'),
    value: '+216',
  },
  {
    label: i18n_t('土耳其 +90'),
    value: '+90',
  },
  {
    label: i18n_t('土库曼斯坦 +993'),
    value: '+993',
  },
  {
    label: i18n_t('危地马拉 +502'),
    value: '+502',
  },
  {
    label: i18n_t('委内瑞拉 +58'),
    value: '+58',
  },
  {
    label: i18n_t('文莱 +673'),
    value: '+673',
  },
  {
    label: i18n_t('乌干达 +256'),
    value: '+256',
  },
  {
    label: i18n_t('乌克兰 +380'),
    value: '+380',
  },
  {
    label: i18n_t('乌拉圭 +598'),
    value: '+598',
  },
  {
    label: i18n_t('乌兹别克斯坦 +233'),
    value: '+233',
  },
  {
    label: i18n_t('西班牙 +34'),
    value: '+34',
  },
  {
    label: i18n_t('希腊 +30'),
    value: '+30',
  },
  {
    label: i18n_t('新加坡 +65'),
    value: '+65',
  },
  {
    label: i18n_t('新西兰 +64'),
    value: '+64',
  },
  {
    label: i18n_t('匈牙利 +36'),
    value: '+36',
  },
  {
    label: i18n_t('叙利亚 +963'),
    value: '+963',
  },
  {
    label: i18n_t('牙买加 +1876'),
    value: '+1876',
  },
  {
    label: i18n_t('也门 +967'),
    value: '+967',
  },
  {
    label: i18n_t('伊拉克 +964'),
    value: '+964',
  },
  {
    label: i18n_t('伊朗 +98'),
    value: '+98',
  },
  {
    label: i18n_t('以色列 +972'),
    value: '+972',
  },
  {
    label: i18n_t('意大利 +39'),
    value: '+39',
  },
  {
    label: i18n_t('印度 +91'),
    value: '+91',
  },
  {
    label: i18n_t('印度尼西亚 +62'),
    value: '+62',
  },
  {
    label: i18n_t('英国 +44'),
    value: '+44',
  },
  {
    label: i18n_t('约旦 +962'),
    value: '+962',
  },
  {
    label: i18n_t('越南 +84'),
    value: '+84',
  },
  {
    label: i18n_t('赞比亚 +260'),
    value: '+260',
  },
  {
    label: i18n_t('乍得 +235'),
    value: '+235',
  },
  {
    label: i18n_t('直布罗陀 +350'),
    value: '+350',
  },
  {
    label: i18n_t('智利 +56'),
    value: '+56',
  },
  {
    label: i18n_t('中非共和国 +236'),
    value: '+236',
  },
  {
    label: i18n_t('扎伊尔 +243'),
    value: '+243',
  },
];
export default phonePrefixOptions;
